import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import { Typography } from "@mui/material";
import { Media } from "../../../../types/common.types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { setMediaSelection } from "../../../../redux/slices/ProductState";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

interface Props {
  media: Media;
  selected?: boolean;
}
const MediaCard = (props: Props) => {
  const isGettingMedia = useSelector(
    (state: RootState) => state.App.isGettingMedia
  );

  const dispatch = useDispatch();

  if (isGettingMedia) {
    return (
      <Box>
        <Stack spacing={1}>
          <Skeleton
            variant="rounded"
            width="100%"
            height={132}
            sx={{ bgcolor: "rgba(122, 101, 96, 0.16)" }}
          />
        </Stack>
      </Box>
    );
  }

  const primaryTag = props.media.tags?.[0];

  return (
    <Box
      onClick={() => {
        dispatch(setMediaSelection({ media: props.media }));
      }}
      sx={{
        position: "relative",
        borderRadius: "9px",
        overflow: "hidden",
        border: `1px solid ${
          props.selected ? "#9e4a50" : "rgba(131, 60, 65, 0.18)"
        }`,
        bgcolor: "#0f0b0b",
        cursor: "pointer",
        aspectRatio: "1 / 1",
        transition: "border-color 0.15s ease, transform 0.15s ease",
        "&:hover": {
          borderColor: "#9e4a50",
          transform: "translateY(-1px)",
        },
      }}
    >
      <img
        src={props.media.photo}
        alt="Uploaded"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(13,10,11,0.02) 45%, rgba(13,10,11,0.74) 100%)",
          pointerEvents: "none",
        }}
      />
      {props.selected && (
        <CheckCircleRoundedIcon
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#f0ece8",
            bgcolor: "#833c41",
            borderRadius: "50%",
            fontSize: 20,
          }}
        />
      )}
      {primaryTag && (
        <Typography
          sx={{
            position: "absolute",
            left: 8,
            right: 8,
            bottom: 7,
            color: "#f0ece8",
            fontSize: "10px",
            fontWeight: 700,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textTransform: "capitalize",
          }}
        >
          {primaryTag}
        </Typography>
      )}
    </Box>
  );
};

export default MediaCard;
